export const educationData = [
  {
    id: 1,
    institution: "Amity University, Noida",
    course: "Master in Computer Application (MCA)",
    startYear: "Jun 2023",
    endYear: "Aug 2025",
    grade: "GPA: 8.0/10"
  },
  {
    id: 2,
    institution: "Masai School, Bangalore",
    course: "Full Stack Web Development (Certification Program)",
    startYear: "Sep 2021",
    endYear: "Mar 2022",
  },
  {
    id: 3,
    institution: "Bir Bikram Memorial College",
    course: "Bachelor of Science (B.Sc) in Physics",
    startYear: "Jul 2018",
    endYear: "Sep 2021",
  },
];